import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, Col } from "antd";
import React from "react";
import { Button } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { labels } from "../../../../localization/labels";
import LocalizationUtil from "../../../../localization/LocalizationUtil";
import SubmitButton from "../../../core/SubmitButton";
import UpdatingPopover from "../../../core/UpdatingPopover";

const constructMessages = (messages, onMessageClick) => {
  var rows = [];

  if (messages) {
    for (let index = 0; index < messages.length; index++) {
      rows.push(
        <span key={index.toString()}>
          <div
            className="popupMessage"
            onClick={() => {
              document.body.click();
              onMessageClick(messages[index].id);
            }}
          >
            <Col>
              <Badge status={"processing"} />
              {messages[index].name}
            </Col>
            <Col className="popupMessageDateTime">
              {LocalizationUtil.localDateTime(messages[index].dispatchDate)}
            </Col>
          </div>
        </span>
      );
    }
  }
  return rows;
};

const NotificationBadge = props => {
  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      opacity="1"
      rootClose
      container={props.containerRef?.current}
      overlay={
        <UpdatingPopover className="popoverContent" id="badge_party_messages">
          <Popover.Title as="h3">{labels.unreadMessages}</Popover.Title>
          <Popover.Content>
            {constructMessages(props.messages, props.onMessageClick)}
            <div className="allMessagesLink">
              <SubmitButton
                type="link"
                text={labels.allMessages}
                onClick={() => {
                  document.body.click();
                  props.onAllMessagesClick();
                }}
                openInNewTab={props.openInNewTab}
              ></SubmitButton>
            </div>
          </Popover.Content>
        </UpdatingPopover>
      }
    >
      <Button className="btnBadge">
        <Badge
          count={props.count}
          title={labels.notificationBadgeMessage}
          offset={[5, 0]}
        >
          <FontAwesomeIcon className="notificationIcon" icon={faBell} />
        </Badge>
      </Button>
    </OverlayTrigger>
  );
};

export default NotificationBadge;
